module.exports = __webpack_public_path__ + "static/media/58796B.10cc24ab.jpg";